import { useEffect, useRef, useState } from "react";
import "./CSS/OurWork.css";
import { useTranslation } from 'react-i18next';

function OurWork() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const workRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const currentRef = workRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section ref={workRef} className={`our-work ${isVisible ? 'fade-in-section' : ''}`}>
      <div className="container">
        <div className="our-work-content">
          <h2 className="our-work-title">{t("OurWork")}</h2>
          <div className="our-work-text">
            <p className="work-paragraph">{t("WorkParagraph")}</p>
            <p className="work-paragraph">{t("WorkParagraph2")}</p>
          </div>
          <a href="/impact" className="learn-more modern-button">{t("LearnMore")}</a>
        </div>
      </div>
    </section>
  );
}

export default OurWork;
